import React, {  useState } from 'react';
import cn from 'classnames';
import style from './menu-link.mod.scss';
import { useMenu } from '../../../context/MenuContext';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import Button from '../../button/button';

const MenuLink = ({ title, anchor, dropdown = false, isHover, page, mobile, button = false }) => {
  const classes = cn(style.link, {
    [style[`link--mobile`]]: mobile,
  });

  const { toggleMenu, isMenuOpen } = useMenu();
  const [location, setLocation] = useState(useLocation());

  const handleClick = (e) => {
    // if(location.pathname !== '/'){
    //   navigate(`/#${anchor}`);
    //   return;
    // }

    e.preventDefault();
  
    const targetElement = document.getElementById(anchor);
    if (targetElement) {
      // Select the mobile menu element by its class name
      const mobileMenu = document.querySelector('.strive--menu--mobile');
      // Get the height of the mobile menu, defaulting to 0 if it's not found
      const mobileMenuHeight = mobileMenu ? mobileMenu.offsetHeight + 10 : 10;
  
      // Only apply the offset if we're on mobile and the menu is open
      const headerOffset = mobile && isMenuOpen ? mobileMenuHeight : 10;
  
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
  
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  
    if (isMenuOpen) {
      toggleMenu();
      toggleMenu();
    }
  };

  return (
    <li className={classes} onClick={handleClick}>
      {button ? (
        <Button key={anchor} text={title} to={`#${anchor}`} size={"sm"} onClick={(e) => handleClick(e)}/>
      ) : (
        <a href={`#${anchor}`} key={anchor} onClick={handleClick}>
          {title}
        </a>
      )}
    </li>
  );
};

export default MenuLink;
